/* Eduplay home: rails + instagram video. Tiny, no deps. */
(function () {
  if (window.__ehInit) return; window.__ehInit = true;

  function initRail(rail) {
    if (rail.__eh) return; rail.__eh = true;
    var track = rail.querySelector('[data-eh-track]');
    if (!track) return;
    var bar = rail.querySelector('.eh-rail__bar'), fill = bar && bar.querySelector('i');
    var prev = rail.querySelector('.eh-rail__nav--prev'), next = rail.querySelector('.eh-rail__nav--next');
    var ticking = false;
    function update() {
      ticking = false;
      var max = track.scrollWidth - track.clientWidth;
      var over = max > 4;
      if (bar) bar.style.display = over ? '' : 'none';
      if (prev) prev.disabled = !over || track.scrollLeft < 4;
      if (next) next.disabled = !over || track.scrollLeft > max - 4;
      if (fill && over) {
        var w = Math.max(.14, track.clientWidth / track.scrollWidth);
        fill.style.width = (w * 100) + '%';
        fill.style.transform = 'translateX(' + ((track.scrollLeft / max) * (1 / w - 1) * 100) + '%)';
      }
    }
    function step(dir) {
      var item = track.firstElementChild;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
      var w = item ? item.getBoundingClientRect().width + gap : track.clientWidth * .8;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    track.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    requestAnimationFrame(update);
  }

  function initInsta(root) {
    if (root.__eh) return; root.__eh = true;
    var cards = [].slice.call(root.querySelectorAll('.eh-insta__card[data-video]'));
    if (!cards.length) return;
    var hover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function vid(c) {
      var v = c.querySelector('video');
      if (!v) {
        v = document.createElement('video');
        v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.preload = 'none';
        v.src = c.dataset.video;
        v.addEventListener('playing', function () { c.classList.add('is-playing'); });
        var im = c.querySelector('img'); if (im) im.insertAdjacentElement('afterend', v); else c.insertBefore(v, c.firstChild);
      }
      return v;
    }
    function play(c) { var p = vid(c).play(); if (p && p.catch) p.catch(function () {}); }
    function stop(c) { var v = c.querySelector('video'); if (v) { v.pause(); } c.classList.remove('is-playing'); }
    if (reduce) return;
    if (hover) {
      cards.forEach(function (c) {
        c.addEventListener('mouseenter', function () { play(c); });
        c.addEventListener('mouseleave', function () { stop(c); });
      });
    } else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.intersectionRatio > .75) play(e.target); else stop(e.target); });
      }, { threshold: [0, .75, 1] });
      cards.forEach(function (c) { io.observe(c); });
    }
  }


  function initAge(sec) {
    if (sec.__eh) return; sec.__eh = true;
    var svg = sec.querySelector('.eh-age__wire'), bsvg = sec.querySelector('.eh-age__beads') || svg; if (!svg) return;
    var rods = [].slice.call(svg.querySelectorAll('path[class^="eh-age__rod"]')), rod = svg.querySelector('.eh-age__rod'), bead = sec.querySelector('.eh-age__bead'), grain = sec.querySelector('.eh-age__grain'), grads = [].slice.call(svg.querySelectorAll('linearGradient'));
    var row = sec.querySelector('.eh-age__row'), tiles = [].slice.call(sec.querySelectorAll('.eh-age__tile'));
    if (!rod || !bead || !tiles.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var bt = 9, small = false, total = 0, C = [], LX = [], LY = [], STEP = 3, stops = [], exits = [], passing = false, since = 1, L = 0, idx = 0, dwell = 0, rest = .6, last = 0, visible = false, paused = false, resumeT = 0, raf = 0, SPEED = 170, DWELL = 1.7, gv = 1;
    function f(n) { return n.toFixed(1); }
    /* Bent metal rod: straight runs joined by rounded bends; each point carries its own bend radius. */
    function wire(P) {
      var d = 'M ' + f(P[0].x) + ' ' + f(P[0].y);
      for (var i = 1; i < P.length - 1; i++) {
        var a = P[i - 1], b = P[i], c = P[i + 1];
        var ux = a.x - b.x, uy = a.y - b.y, la = Math.hypot(ux, uy), vx = c.x - b.x, vy = c.y - b.y, lc = Math.hypot(vx, vy);
        if (la < 1e-3 || lc < 1e-3) continue;
        ux /= la; uy /= la; vx /= lc; vy /= lc;
        var th = Math.acos(Math.max(-1, Math.min(1, ux * vx + uy * vy)));
        if (th > Math.PI - 1e-3 || !b.r) { d += ' L ' + f(b.x) + ' ' + f(b.y); continue; }
        var t = Math.min(b.r / Math.tan(th / 2), la / 2, lc / 2), rr = t * Math.tan(th / 2);
        var sweep = ((-ux) * vy - (-uy) * vx) > 0 ? 1 : 0;
        d += ' L ' + f(b.x + ux * t) + ' ' + f(b.y + uy * t) + ' A ' + f(rr) + ' ' + f(rr) + ' 0 0 ' + sweep + ' ' + f(b.x + vx * t) + ' ' + f(b.y + vy * t);
      }
      var z = P[P.length - 1];
      return d + ' L ' + f(z.x) + ' ' + f(z.y);
    }
    /* points along the rod are measured once per layout, so animation frames never call getPointAtLength */
    function at(l) { l = Math.max(0, Math.min(total, l)); var i = l / STEP, j = Math.floor(i), k = Math.min(j + 1, LX.length - 1), t = i - j; return { x: LX[j] + (LX[k] - LX[j]) * t, y: LY[j] + (LY[k] - LY[j]) * t }; }
    function build() {
      var sr = sec.getBoundingClientRect(); if (!sr.width) return;
      var W = sr.width, H = sr.height;
      SPEED = Math.max(95, Math.min(220, W * .15)); small = W < 750;
      [svg, bsvg].forEach(function (s) { s.setAttribute('viewBox', '0 0 ' + f(W) + ' ' + f(H)); });
      C = tiles.map(function (t) { var r = t.getBoundingClientRect(); return { x: r.left - sr.left + r.width / 2, y: r.top - sr.top + r.height / 2, r: r.width / 2 }; });
      var y = C[0].y, R = C[0].r, P = [], lx = C[0].x - R;
      function pt(x, yy, r) { P.push({ x: x, y: yy, r: r }); }
      /* enter from the left with one soft step */
      if (lx > 80) { var e0 = lx * .5, s0 = Math.min(R * .5, 44); pt(-40, y + s0, 0); pt(e0, y + s0, 22); pt(e0, y, 22); }
      else pt(-40, y, 0);
      /* the rod leaves each circle from its side and makes one even loop in the gap: over, under, over */
      for (var i = 0; i < C.length - 1; i++) {
        var a = C[i], b = C[i + 1], sx = a.x + a.r, ex = b.x - b.r, g = ex - sx;
        if (g < 56) continue;
        var up = i % 2 === 0 ? -1 : 1, m = Math.min(8, g * .06), p1 = sx + m, p2 = ex - m, w = p2 - p1;
        var base = Math.min(16, w * .2), h = Math.min(R * (up < 0 ? 1 : .86), w * .62 + base);
        pt(p1, y, base); pt(p1, y + up * h, w / 2); pt(p2, y + up * h, w / 2); pt(p2, y, base);
      }
      /* leave to the right with one soft step */
      var z = C[C.length - 1], rx = z.x + z.r, rw = W - rx;
      if (rw > 80) { var e1 = rx + rw * .5, s1 = Math.min(R * .5, 44); pt(e1, y, 22); pt(e1, y - s1, 22); pt(W + 40, y - s1, 0); }
      else pt(W + 40, y, 0);
      var d = wire(P);
      rods.forEach(function (p) { p.setAttribute('d', d); });
      grads.forEach(function (gr) { gr.setAttribute('x1', f(C[0].x)); gr.setAttribute('x2', f(z.x)); });
      total = rod.getTotalLength(); LX = []; LY = [];
      /* getPointAtLength is slow (it walks the whole path each call): sample every 4th point and fill in between,
         which cut this from ~90ms (a visible hitch while scrolling) to a fraction of that */
      var CS = STEP * 4, cx = [], cy = [];
      for (var l = 0; l <= total + CS; l += CS) { var q = rod.getPointAtLength(Math.min(l, total)); cx.push(q.x); cy.push(q.y); }
      for (var l = 0; l <= total + STEP; l += STEP) { var fi = l / CS, j = Math.min(Math.floor(fi), cx.length - 2), ft = fi - j; LX.push(cx[j] + (cx[j + 1] - cx[j]) * ft); LY.push(cy[j] + (cy[j + 1] - cy[j]) * ft); }
      stops = []; exits = []; var from = 0;
      C.forEach(function (p) {
        var en = -1, ex = -1, hit = p.r + (small ? 5 : 9);
        for (var s = Math.floor(from / STEP); s < LX.length; s++) {
          var dd = Math.hypot(LX[s] - p.x, LY[s] - p.y), l2 = s * STEP;
          if (en < 0 && dd <= hit) en = l2;
          if (en >= 0) { if (dd <= hit) ex = l2; else if (l2 - ex > 4) break; }
        }
        if (en < 0) en = ex = from;
        stops.push(en); exits.push(Math.min(ex, total)); from = ex;
      });
      if (L > total) L = 0;
      place();
    }
    function clear() { tiles.forEach(function (t) { t.classList.remove('is-bloom'); }); }
    function place() {
      if (!total) return;
      var off = dwell > 0 ? (small ? 9 : 16) * Math.exp(-5 * bt) * Math.abs(Math.sin(11 * bt)) : 0, l = Math.max(0, L - off), p = at(l), sc = small ? .58 : 1;
      bead.setAttribute('transform', 'translate(' + f(p.x) + ' ' + f(p.y) + ')' + (small ? ' scale(.58)' : ''));
      if (grain) grain.setAttribute('transform', 'rotate(' + f((l / (9.5 * sc)) * 57.2958 % 360) + ')');
      var o = (L < 30 || L > total - 30 || passing) ? '0' : '1'; if (bead.style.opacity !== o) bead.style.opacity = o;
    }
    /* gentle gravity: a touch slower climbing, a touch quicker coming down */
    function grav(dt) { var a = at(L - 3), b = at(L + 3), g = Math.max(.6, Math.min(1.4, 1 + .5 * (b.y - a.y) / 6)); gv += (g - gv) * Math.min(1, dt * 4); return gv; }
    function tick(now) {
      raf = 0; var dt = Math.min(.05, (now - (last || now)) / 1000); last = now;
      if (!visible || !total) return;
      if (paused) { if (resumeT && now > resumeT) { paused = false; resumeT = 0; } else { raf = requestAnimationFrame(tick); return; } }
      if (rest > 0) rest -= dt;
      else if (dwell > 0) { dwell -= dt; bt += dt; if (dwell <= 0) { tiles[idx].classList.remove('is-bloom'); passing = true; } }
      else if (passing) { L += SPEED * 1.4 * dt; if (L >= exits[idx]) { passing = false; idx++; since = 0; } }
      else {
        var ahead = idx < stops.length ? stops[idx] - L : 1e9;
        since += dt;
        L += SPEED * dt * grav(dt) * Math.max(.7, Math.min(1, ahead / 70)) * Math.min(1, .5 + since / .8);
        if (idx < stops.length && L >= stops[idx]) { L = stops[idx]; tiles[idx].classList.add('is-bloom'); dwell = DWELL; bt = 0; }
        if (L >= total) { L = 0; idx = 0; rest = 1.4; }
      }
      place(); raf = requestAnimationFrame(tick);
    }
    function start() { if (!raf && !reduce) { last = 0; raf = requestAnimationFrame(tick); } }
    function pause(ms) { paused = true; resumeT = ms ? performance.now() + ms : 0; clear(); if (dwell > 0 || passing) { dwell = 0; passing = false; if (idx < exits.length) { L = exits[idx]; idx++; } } bead.style.opacity = 0; }
    /* measuring the rod is the costly part, so it waits until the section is about to scroll into view */
    var ready = false, rt, first = true;
    function later() { if (!ready) return; clearTimeout(rt); rt = setTimeout(build, 150); }
    window.addEventListener('resize', later, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(function () { if (first) { first = false; return; } later(); }).observe(row);
    new IntersectionObserver(function (es, o) { if (!es[0].isIntersecting) return; o.disconnect(); ready = true; build(); if (visible) start(); }, { rootMargin: '300px 0px' }).observe(sec);
    if (reduce) return;
    row.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') pause(0); });
    row.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { paused = false; start(); } });
    row.addEventListener('touchstart', function () { pause(5000); }, { passive: true });
    new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) start(); else clear(); }, { threshold: .4 }).observe(sec);
  }

  function boot() {
    document.querySelectorAll('[data-eh-rail]').forEach(initRail);
    document.querySelectorAll('[data-eh-insta]').forEach(initInsta);
    document.querySelectorAll('[data-eh-age]').forEach(initAge);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
